<template>
    <div :class="cssClass">
        <cogi-label cssClass="grid-full" :required="required" :label="label" />
        <cogi-checkbox cssClass="grid-full" v-if="tousVisible" v-model="selectAll" label="Tous" :hasError="hasError" />
        <div class="grid-6">
            <div :class="'gridspan' + 6 / nbColonnesAffichage">
                <cogi-checkbox
                    v-for="item in getItemsColonne(1)"
                    :key="item.listItemId"
                    :label="loadDescription(item)"
                    :dontTranslate="true"
                    :modelValue="model?.includes(item.value!)"
                    @update:modelValue="newValue => setItemSelection(item, newValue ?? false)"
                    :hasError="hasError" />
            </div>
            <div v-if="nbColonnesAffichage > 1" :class="'gridspan' + 6 / nbColonnesAffichage">
                <cogi-checkbox
                    v-for="item in getItemsColonne(2)"
                    :key="item.listItemId"
                    :label="loadDescription(item)"
                    :dontTranslate="true"
                    :modelValue="model?.includes(item.value!)"
                    @update:modelValue="newValue => setItemSelection(item, newValue ?? false)"
                    :hasError="hasError" />
            </div>
            <div v-if="nbColonnesAffichage > 2" :class="'gridspan' + 6 / nbColonnesAffichage">
                <cogi-checkbox
                    v-for="item in getItemsColonne(3)"
                    :key="item.listItemId"
                    :label="loadDescription(item)"
                    :dontTranslate="true"
                    :modelValue="model?.includes(item.value!)"
                    @update:modelValue="newValue => setItemSelection(item, newValue ?? false)"
                    :hasError="hasError" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, watch, computed } from 'vue'
    import CogiLabel from './CogiLabel.vue'
    import CogiCheckbox from './CogiCheckbox.vue'
    import type { del } from '../../../clients/delclient'

    interface IPropsCheckboxgroup {
        label?: string
        sourceItems: del.ListItem[]
        tousVisible?: boolean
        codeVisible?: boolean
        required: boolean
        cssClass: string
        valideNow?: boolean
        culture: string
        nbColonnesAffichage?: number
    }

    const props = withDefaults(defineProps<IPropsCheckboxgroup>(), {
        label: '',
        required: false,
        cssClass: '',
        valideNow: false,
        culture: 'fr',
        nbColonnesAffichage: 1,
    })

    const model = defineModel<string[]>()
    const hasError = ref(false)

    const selectAll = computed<boolean>({
        get() {
            return props.sourceItems.every(s => model.value?.includes(s.value!))
        },
        set(newValue) {
            model.value = newValue ? props.sourceItems.map(s => s.value!) : []
        },
    })

    function setItemSelection(item: del.ListItem, newValue: boolean) {
        if (newValue) {
            if (model.value == undefined) {
                model.value = [item.value!]
            } else {
                model.value.push(item.value!)
            }
        } else {
            model.value = model.value?.filter(i => i != item.value!)
        }
    }

    const emit = defineEmits<{
        validated: [boolean]
    }>()

    function loadDescription(item: del.ListItem) {
        return (props.codeVisible ? item.value + '-' : '') + (props.culture == 'fr' ? item.description : item.descriptionAnglais)
    }

    function validate() {
        hasError.value = props.required && (model.value?.length ?? 0) == 0
        emit('validated', hasError.value)
    }

    function getNbElementsColonne(rangColonne: number) {
        if (rangColonne > props.nbColonnesAffichage) return 0

        let nbElements = Math.floor(props.sourceItems.length / props.nbColonnesAffichage)
        if (props.sourceItems.length % props.nbColonnesAffichage >= rangColonne) nbElements++

        return nbElements
    }

    function getItemsColonne(rangColonne: number) {
        let nbElementsColPrecedentes = 0
        for (let i = rangColonne - 1; i > 0; i--) nbElementsColPrecedentes += getNbElementsColonne(i)

        return props.sourceItems.slice(nbElementsColPrecedentes, nbElementsColPrecedentes + getNbElementsColonne(rangColonne))
    }

    watch(
        () => props.valideNow,
        newValue => {
            if (newValue) validate()
        },
    )
</script>
